import React from 'react';
import { Tag, Space, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import Logo from "../../../components/Graphics/Logo"; // Adjust the path as necessary

const SelectedItem = ({ ticker, onRemove }) => {
  return (
    <Tag
      style={{
        padding: '5px 10px',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#f0f2f5', // Soft background color for modern look
        border: 'none', // Removing the border for a modern tag look
      }}
      closable
      onClose={(e) => {
        e.preventDefault();
        onRemove(ticker.symbol);
      }}
    >
      <Space>
        <Logo src={ticker?.logo ?? ''} alt={`${ticker.symbol} logo`} style={{ width: '20px' }} />
        <span>{ticker.symbol}</span> - <span>{ticker?.name ?? ''}</span>
      </Space>
    </Tag>
  );
};

export default SelectedItem;
